// Success alert messages
export const GENERIC_SUCCESS_TITLE = "Success";
export const GENERIC_SUCCESS_MESSAGE = "Your request has been processed successfully.";

export const LOGIN_SUCCESS_MESSAGE = "You have successfully logged in.";

// Failed form messages
export const E_ENTER_EMAIL_ADDRESS = "Please enter a valid email address.";
export const E_ENTER_PASSWORD = "Please enter your password.";
export const E_FIELD_REQUIRED = "This field is required.";
export const E_CONFIRM_PASSWORD = "Please confirm your password.";
export const E_PASSWORD_NOT_MATCHED = "Password not matched.";
export const E_REQUIRED_BIRTHDATE = "Birth date is required";

// Failed alert messages
export const E_GENERIC_TITLE = "Failed";
export const E_GENERIC_MESSAGE = "An error occurred while processing your request. Please try again later.";
export const E_MULTIPLE_LOGIN_DETECTED = "Multiple logins were detected. Our system has detected that your account is logged in to another device with different IP address.";
export const E_MULTIPLE_LOGIN_DETECTED_SUB = "Note that sharing of online review access is strictly prohibited and subject to penalties. It may result in the termination of your account. The status of your account will be further investigated and reviewed by our team.";
export const E_ACCOUNT_DEACTIVATED = "Your account has been deactivated.";
export const E_ATTEMPT_MAX_REACHED = "You already reached the maximum attempts for this exam.";
// s3 URLs
export const PREBOARD_LOGO_URL = "https://sgp1.digitaloceanspaces.com/pinnacleassets/preboard-assets/2025-10-15-1760531781345.svg";
export const PREBOARD_LOGO_WITH_TEXT_URL = "https://sgp1.digitaloceanspaces.com/pinnacleassets/preboard-assets/2025-11-27-1764248430719.svg";
export const PREBOARD_AUTH_BANNER_DESKTOP_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-10-15-1760531309382.svg";
export const PREBOARD_AUTH_BANNER_MOBILE_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-12-02-1764687174887.svg";
export const PREBOARD_ACTIVATE_CODE_IMG_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-12-04-1764828036792.svg";
export const PREBOARD_TAKE_EXAM_SPLASH = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-12-16-1765861634209.svg";
export const SIDEBAR_AVATAR_COVER_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-10-17-1760700424441.svg";
export const EXAM_BOOKMARK_LOGO_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-10-26-1761473983067.svg";
export const STAR_PROGRESS_LOGO_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-10-26-1761474251276.svg";
export const EXAM_RESULTS_LOGO_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-10-26-1761474619320.svg";
export const FILE_PROGRESS_LOGO_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-10-26-1761475224953.svg";
export const TOP_PROGRESS_LOGO_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-10-26-1761475281338.svg";
export const SETTINGS_COG_LORO_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-11-09-1762689777496.svg";
export const TERMS_LOGO_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-12-18-1766032343554.svg";
export const EMPTY_STATE_ILLUSTRATION_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-10-26-1761480229261.svg";
export const EXAM_SELECT_CODE = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-11-09-1762676869646.svg";
export const SIDEBAR_LOGO = "https://pinnacleassets.sgp1.digitaloceanspaces.com/admin-assets/2025-07-23-1753277110545.png";
export const NO_DATA_TO_DISPLAY_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/admin-assets/2025-07-24-1753368012546.png";
export const VIMEO_PLAYER_URL = "https://player.vimeo.com/video";
export const HOW_TO_GET_VIMEOID_TUTORIAL_GIF = "https://sgp1.digitaloceanspaces.com/pinnacleassets/admin-assets/2025-08-26-1756197317271.gif";
// keys
export const PREBOARD_STORAGE_KEY = "preboardStudentV1AccessToken";
export const PREBOARD_DASHBOARD_NAME = "preboardStudentV1AdminName";

// Logout
export const SUCCESSFULLY_LOGGED_OUT_MSG = "You have successfully logged out.";
export const CONFIRM_LOGOUT_MSG = "Are you sure you want to log out?";

export const DEFAULT_PAGE_LIMIT = 15;

// export const tinyEditorApiKey = 'sr8gha99ek0kb05xtzsxcrbenlp6vcsvf20fftq877i1bzzk';
export const tinyEditorApiKey = 'qvoiwk2jjhxxsigosxz3sgz6xxlby0jo9pcwj1uk5ythlquc';

// Style constants
export const PRIMARY_COLOR = '#5840BA';
export const SECONDARY_COLOR = '#FFFFFF';

export const CALCULATOR_BG = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2026-06-14-1781446233713.svg";

export const PINNACLE_LOGO_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/admin-assets/2025-07-23-1753273550065.png";

export const PREBOARD_AUTH_BANNER_DESKTOP_LATEST = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2026-06-13-1781353588955.png";

export const PREBOARD_AUTH_BANNER_MOBILE_LATEST = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2026-06-13-1781354136801.png";